import { useNavigate } from "react-router-dom";
import { useAuth } from "@/AuthContext";
import { LogOut } from "lucide-react";

export default function EmpProfile() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="p-5 space-y-5" data-testid="emp-profile-page">
      <div className="bg-surface border border-border rounded-2xl p-5 text-center">
        <div className="w-16 h-16 mx-auto rounded-full bg-primary/20 text-primary flex items-center justify-center font-heading font-extrabold text-2xl">
          {user.name?.[0]}
        </div>
        <div className="font-heading font-bold text-lg mt-3">{user.name}</div>
        <div className="text-xs text-muted-foreground">{user.email}</div>
        <div className="text-xs text-muted-foreground">{user.phone}</div>
        <div className="mt-2 inline-block text-[10px] font-bold px-2.5 py-1 rounded-full border border-primary/40 text-primary">FIELD STAFF</div>
      </div>
      <button data-testid="emp-logout-button" onClick={async () => { if (await logout()) nav("/login"); }}
        className="w-full py-4 rounded-xl bg-surface border border-danger text-danger-foreground font-bold flex items-center justify-center gap-2">
        <LogOut size={18} /> Logout
      </button>
    </div>
  );
}
